import { FC, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useCateQuery } from "../../../../api/queries/cateQueries";
import { TPassProductListPickerProps } from "./PassProductListPicker";

export const TtCategoryLs: FC<TPassProductListPickerProps> = (jj) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  console.log("TtCategoryLs render", jj.selectedProductType);
  const cateQuery = useCateQuery(null); //jj.selectedProductType
  const { t } = useTranslation();
  // const ls = useMemo(
  //   () =>
  //     cateQuery?.data?.filter(
  //       (x) =>
  //         (!x.defaultCategory || x.name === "SIM") &&
  //         x.name !== "Night tour" &&
  //         !!x.name,
  //     ) ?? [],
  //   [cateQuery?.data],
  // );

  const ls = useMemo(() => {
  const rawCategories =
    cateQuery?.data?.filter(
      (x) =>
        (!x.defaultCategory || x.name === "SIM") &&
        x.name !== "Night tour" &&
        !!x.name,
    ) ?? [];

  // ✅ Lấy tất cả categoryId của sản phẩm
  const categoryIds = new Set(
    jj.allProducts.map((p) => p.categoryId).filter(Boolean),
  );

  // ✅ Lọc ra những category có trong danh sách sản phẩm
  return rawCategories.filter((c) => categoryIds.has(c.id));
}, [cateQuery?.data, jj.allProducts]);


  useEffect(
    function () {
      // if (jj.selectedProductType === "TOUR") {
      //   // TOUR chỉ có day tour, chọn luôn day tour
      //   jj.setSelectedCategory(ls[0]?.id ?? null);
      //   return;
      // }
      jj.setSelectedCategory(null);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ls],
  );

  if (!cateQuery?.data) return null;

  const handleMouseDown = (e: React.MouseEvent) => {
    const container = scrollContainerRef.current;

    if (!container) return;

    container.style.cursor = "grabbing";
    container.style.userSelect = "none";

    const startX = e.pageX - container.offsetLeft;
    const scrollLeft = container.scrollLeft;

    const handleMouseMove = (e: MouseEvent) => {
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2;
      container.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUp = () => {
      container.style.cursor = "grab";
      container.style.removeProperty("user-select");
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };
  // if (jj.selectedProductType === "TOUR" || !ls?.length) {
  //   // TOUR chỉ có day tour, nen k cân hiện
  //   return <div className="pt-8"></div>;
  // }

  return (
    <div
      ref={scrollContainerRef}
      className="scrollable-container my-8 flex max-w-full cursor-grab overflow-x-auto whitespace-nowrap"
      onMouseDown={handleMouseDown}
    >
      <button
        key={"all"}
        className={`mr-3 rounded-[3.125rem] px-[1.0625rem] py-2 text-[0.875rem] font-normal leading-[1.25rem] ${
          jj.selectedCategory === null
            ? "bg-black font-semibold text-white"
            : "border border-[#EAEEF3] bg-white"
        }`}
        onClick={() => jj.handleCategoryClick(null)}
      >
        {t("All")}
      </button>
      {ls.map((category) => (
        <button
          key={category.id}
          className={`mr-3 rounded-[3.125rem] px-[1.0625rem] py-2 text-[0.875rem] font-normal leading-[1.25rem] ${
            jj.selectedCategory === category.id
              ? "bg-black font-semibold text-white"
              : "border border-[#EAEEF3] bg-white"
          }`}
          onClick={() => jj.handleCategoryClick(category.id)}
        >
          {t(category.name)}
        </button>
      ))}
    </div>
  );
};
